import React, { Component } from 'react';
import { EditorState, convertFromRaw } from 'draft-js';
import { getContentState } from '../../../../../../../../RichTextEditor';
import CommentAssets from '../../../../../../CommentAssets';
import Header from './Header';
import Content from './Content';
import Controls from './Controls';
import '../styles/_editable-comment.scss';


























class EditableComment extends Component {
  constructor(props) {
    super(props);

    const { comment: { content }, toggleEditMode, editMode } = props;
    let editorState = EditorState.createEmpty();

    if (editMode && toggleEditMode) {
      const contentState = convertFromRaw(content);
      editorState = EditorState.createWithContent(contentState);
      this.setState({ editorState });
      toggleEditMode({ toggle: true });
    }

    this.state = {
      busy: false,
      editorState,
      assetIds: props.comment.assetIds
    };
  }

  handleUpdate = async () => {
    const {
      updateComment,
      comment: { commentId },
      toggleEditMode,
      editMode
    } = this.props;

    const { editorState, assetIds } = this.state;

    const { json, plainText } = getContentState(editorState);

    if (!plainText.trim() || !editMode) {return;}

    this.setState({ busy: true });

    const { error } = await updateComment(commentId, { content: json, assetIds });

    this.setState({ busy: false });

    if (error) {return;}

    toggleEditMode({ toggle: false });
  };

  handleCancel = () => {
    const { toggleEditMode } = this.props;

    toggleEditMode({ toggle: false });
  };

  handleDelete = async () => {
    const {
      deleteComment,
      closePopover,
      comment: { commentId },
      onDeleteComment
    } = this.props;

    closePopover();

    deleteComment({ commentId, onSuccess: onDeleteComment });
  };

  handleUpdateContent = (editorState) => this.setState({ editorState });

  handleFilesChange = (assetIds) => {this.setState({ assetIds });};

  onToggleEditMode = ({ toggle }) => {
    const { toggleEditMode, comment } = this.props;
    const { content } = comment || {};

    if (!toggle) {return void toggleEditMode({ toggle });}

    const contentState = convertFromRaw(content);
    const editorState = EditorState.createWithContent(contentState);

    this.setState({ editorState });

    toggleEditMode({ toggle });
  };

  render() {
    const {
      comment,
      onUpdateCheckbox,
      canResolveComment,
      createReply,
      editMode,
      isReadOnly,
      resourceOrganisationId,
      isResourceOwner,
      onInputFocus,
      sceneId,
      shotId
    } = this.props;

    if (!comment) {
      return null;
    }

    const { commentId, content } = comment;
    const { busy, editorState, assetIds } = this.state;
    const { plainText } = getContentState(editorState);
    const canSave = Boolean(plainText.trim());

    return (
      <div className="editable-comment">
        <div className="editable-comment__header-content-wrapper">
          <Header
            comment={comment}
            onUpdateCheckbox={onUpdateCheckbox}
            canResolveComment={canResolveComment} />

          <div className="editable-comment__content-wrapper">
            <Content
              commentId={commentId}
              editMode={editMode}
              content={content}
              assetIds={assetIds}
              editorState={editorState}
              onUpdateContent={this.handleUpdateContent}
              onSave={this.handleUpdate}
              onCancel={this.handleCancel}
              onFilesChange={this.handleFilesChange}
              resourceOrganisationId={resourceOrganisationId} />

            {!editMode && assetIds ?

            <CommentAssets
              assetIds={assetIds}
              commentId={commentId}
              onFilesChange={this.handleFilesChange} /> :


            null}
          </div>
        </div>
        <Controls
          editMode={editMode}
          busy={busy}
          comment={comment}
          createReply={createReply}
          toggleEditMode={this.onToggleEditMode}
          handleUpdate={this.handleUpdate}
          handleDelete={this.handleDelete}
          canSave={canSave}
          isReadOnly={isReadOnly}
          resourceOrganisationId={resourceOrganisationId}
          isResourceOwner={isResourceOwner}
          onInputFocus={onInputFocus}
          sceneId={sceneId}
          shotId={shotId} />

      </div>);

  }
}

export default EditableComment;